import React, { Dispatch, SetStateAction, useEffect } from "react";
import { Text, Stack } from "@chakra-ui/react";
import {
  Pagination,
  usePagination,
  PaginationPage,
  PaginationNext,
  PaginationPrevious,
  PaginationPageGroup,
  PaginationContainer,
  PaginationSeparator,
} from "@ajna/pagination";

// limits in pagination
const outerLimit = 1;
const innerLimit = 1;

interface PaginateProp {
  setPageNum?: Dispatch<SetStateAction<number>>;
  onChangePage?: (pageChanged: number) => void;
  totalRecords: number;
  pageSize: number;
  pageNum?: number;
}

const PaginationBar: React.FC<PaginateProp> = ({
  totalRecords,
  pageSize,
  setPageNum,
  onChangePage,
  pageNum,
}) => {
  //pagination hook
  const { pages, pagesCount, currentPage, setCurrentPage, isDisabled } =
    usePagination({
      total: totalRecords,
      limits: {
        outer: outerLimit,
        inner: innerLimit,
      },
      initialState: {
        pageSize: pageSize,
        isDisabled: false,
        currentPage: 1,
      },
    });
  useEffect(() => {
    if (pageNum && pageNum !== currentPage) {
      setCurrentPage(pageNum);
    }
  }, [pageNum, setCurrentPage, currentPage]);
  const handlePageChange = (nextPage: number): void => {
    // -> request new data using the page number
    setCurrentPage(nextPage);
    onChangePage?.(nextPage);
    setPageNum?.(nextPage);
  };
  return (
    <Stack>
      {totalRecords > pageSize && (
        <Pagination
          pagesCount={pagesCount}
          currentPage={currentPage}
          isDisabled={isDisabled}
          onPageChange={handlePageChange}
        >
          <PaginationContainer
            align="center"
            justify="space-between"
            py={4}
            w="full"
          >
            <PaginationPrevious
              _hover={{
                bg: "yellow.400",
              }}
              bg="yellow.500"
              color={"white"}
              mr="8px"
            >
              <Text color={"white"}>Previous</Text>
            </PaginationPrevious>
            <PaginationPageGroup
              isInline
              align="center"
              separator={
                <PaginationSeparator
                  bg="black.300"
                  fontSize="sm"
                  w={7}
                  jumpSize={11}
                />
              }
            >
              {pages.map((page: number) => (
                <PaginationPage
                  borderColor="black"
                  borderStyle="solid"
                  bg="white.300"
                  minW="40px"
                  paddingInline="10px"
                  key={`pagination_page_${page}`}
                  page={page}
                  fontSize="sm"
                  mr="4px"
                  _hover={{
                    bg: "yellow.400",
                  }}
                  _current={{
                    bg: "yellow.500",
                    fontSize: "sm",
                    color: "white",
                  }}
                />
              ))}
            </PaginationPageGroup>
            <PaginationNext
              _hover={{
                bg: "yellow.400",
              }}
              bg="yellow.500"
              color={"white"}
            >
              <Text color={"white"}>Next</Text>
            </PaginationNext>
          </PaginationContainer>
        </Pagination>
      )}
    </Stack>
  );
};

export default PaginationBar;
